import { render, staticRenderFns } from "./MasonryPage.vue?vue&type=template&id=a16296ea&scoped=true&"
import script from "./MasonryPage.vue?vue&type=script&lang=js&"
export * from "./MasonryPage.vue?vue&type=script&lang=js&"
import style0 from "./MasonryPage.vue?vue&type=style&index=0&id=a16296ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16296ea",
  null
  
)

export default component.exports